import { ADD_PROCEED_URL, ADD_MERCHANT_INFO,ISREPEATCUSTOMER } from "../constants/env-resolver";
import client from "./axios-instance";
import Axios from 'axios';
import debug from '../debug';
// export function addProceedURL(payload) {
//   return client.post(ADD_PROCEED_URL, payload);
// }

export function addProceedURL(payload,token) {
    return dispatch =>
      Axios
        .post(ADD_PROCEED_URL, payload,
         {
            headers: {
              customerid: payload.customerId,
              authorization: token,
            },
          })
        .then(res => {
            console.log('res',res);
          if (res.status === 200) {
            return res.data;
          } else {
            throw new Error(res);
          }
        })
        .catch(function (err) {
          debug('ERROR', err);
        });
  }


export function getMerchantDetls(payload) {
  return client.post(ADD_MERCHANT_INFO, payload);
}

  export function checkRepeatCustomer(payload,token) {
    return Axios.post(ISREPEATCUSTOMER, payload, {
        headers: {
          customerid: payload.customerId,
          authorization: token,
        },
      });
  }
